import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useAccessToken } from '@/services/auth';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

export type MoveSireGroupRequest = {
  sessionId: string;
  sireId: string;
  semenType?: string;
  collectionCode?: string;
  sireNote?: string;
  sourceRunId: string;
  targetRunId: string;
};

export const useMoveSireGroupBetweenRunsMutation = () => {
  const queryClient = useQueryClient();
  const token = useAccessToken();

  return useMutation({
    mutationFn: async ({
      sessionId,
      sireId,
      semenType,
      collectionCode,
      sireNote,
      sourceRunId,
      targetRunId,
    }: MoveSireGroupRequest): Promise<void> => {
      const response = await fetch(
        `${API_BASE_URL}/api/fertwork/session/${sessionId}/runs/move-sire-group`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
            'X-Tunnel-Authorization': `tunnel ${import.meta.env.VITE_DEV_TUNNEL_TOKEN}`,
          },
          credentials: 'include',
          body: JSON.stringify({
            sireId,
            semenType,
            collectionCode,
            sireNote,
            sourceRunId,
            targetRunId,
          }),
        },
      );

      if (!response.ok) {
        const error = await response.text();
        throw new Error(error || `HTTP error ${response.status}`);
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['fertWorkRuns'] });
    },
  });
};
